<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Catálogo de Promociones</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:end" class="textoSubtitulo">Tx_01</p>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="mt-2 col-md-12"></div>

      <b-container fluid="">
        <b-row>
          <b-col>
            <div>

              <b-row class="text-center mt-4">
                <b-col cols="1" md="3">
                </b-col>

                <b-col cols="9" md="6" >
                  <b-row class="contenedorTablaSinColor" style="background:white ">
                    <b-col cols="10" lg="11" class="pr-0">
                      <b-input-group class="pl-3" v-if="$localStorageService.can('Promociones_buscar')" >
                        <b-form-input
                            class="input-filter"
                            maxLength="55"
                            v-model="nombrePromocion"
                            type="search"
                            id="filterInput"
                            responsive
                            placeholder="Búsqueda de Promociones"
                            @keydown.enter.native="buscarPromos"
                        >
                        </b-form-input>

                      </b-input-group>
                    </b-col>
                    <b-col cols="2" lg="1" class="pl-0">
                      <b-button
                          class="mt-1 pb-1"
                          size="sm"
                          variant="info"
                          pill
                          :disabled="loading"
                          @click="buscarPromos()"
                          responsive
                      >
                        <em v-if="!loading" class="buscar_svg primary sm"></em>
                        <span v-else><b-spinner small></b-spinner></span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="3" class="text-right mt-auto mb-auto">
                  <b-button
                      v-if="$localStorageService.can('Promociones_nuevo')"
                      variant="ligth"
                      v-b-tooltip.hover.lefttop.v-light
                      title="Crear Promo"
                      class="paddingbotones "
                      pill
                      @click="crearNuevaPromo()"
                      responsive
                  ><em class="btn_plus_circle"
                       style="width: 24px;"/>
                  </b-button>
                </b-col>
              </b-row>


              <b-row >
                <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                  <b-table
                      :hover="true"
                      :small="true"
                      style="font-size: 12px !important; padding: 0.1rem;"
                      responsive
                      fixed
                      :fields="fields"
                      :items="items"
                      :per-page="registrosPorPagina"
                      :current-page="currentPage"
                      thead-tr-class="columnasTablaSinColorLetter"
                  >
                    <template v-slot:cell(fechaAlta)="row">
                      {{row.item.fechaAlta | formatoFecha}}
                    </template>
                    <template v-slot:cell(fechaModificacion)="row">
                      {{row.item.fechaModificacion | formatoFecha}}
                    </template>
                    <template v-slot:cell(del)="row">
                      <div v-if="row.item.idTipoVigencia == 1">
                        {{row.item.fechaInicio | formatoFecha}}
                      </div>
                      <div v-else>
                        {{row.item.fechaInicioCita | formatoFecha}}
                      </div>
                    </template>
                    <template v-slot:cell(al)="row">
                      <div v-if="row.item.idTipoVigencia == 1">
                        {{row.item.fechaFin | formatoFecha}}
                      </div>
                      <div v-else>
                        {{row.item.fechaFinCita | formatoFecha}}
                      </div>
                    </template>

                    <template v-slot:cell(Acciones)="row" style="width: 200px">
                      <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                                v-b-tooltip.hover
                                title="Editar"
                                @click="editarPromo(row.item.idPromocion)"
                                v-if="row.item.registroActivo && $localStorageService.can('Promociones_editar')"
                      >
                        <em class="editar_svg sm"></em>
                      </b-button>

                      <b-button size="sm" variant="outline-success" class="mr-1 mt-1 marginbotones"
                                v-b-tooltip.hover
                                title="Activar Promoción"
                                @click="validarReactivacion(row.item)"
                                v-if="!row.item.registroActivo && $localStorageService.can('Promociones_inactivar')"
                      >
                        <em class="fa fa-undo" ></em>

                      </b-button>
                      <b-button size="sm" variant="outline-danger" class=" marginbotones"
                                v-b-tooltip.hover
                                title="Desactivar Promoción"
                                v-if="row.item.registroActivo && $localStorageService.can('Promociones_inactivar')"
                                @click="cambiarEstatusPromo(row.item.idPromocion, false, row.item)"
                      >
                        <em class="fa fa-trash" style="color: red"></em>
                      </b-button>
                    </template>

                  </b-table>
                  <div align="center" v-if="loading">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <b-col v-else-if="!loading">
                    <b-alert v-if="items.length === 0" variant="success" show>No hay datos</b-alert>
                  </b-col>
                </b-col >
                <div class="mt-2 w-100 flex justify-content-center align-items-end" v-if="!loading">
                  <b-pagination
                      v-if="items !== undefined && items.length > 10"
                      align="center"
                      v-model="currentPage"
                      :total-rows="items.length"
                      :per-page="registrosPorPagina"
                  ></b-pagination>
                </div>
              </b-row>

            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>



  </div>

</template>

<script>
import Header from "@/components/Header";
import {PromocionesService} from "@/apiServices/promociones/PromocionesService";
import miniToastr from "mini-toastr";
export default {
  name: "ListaPromociones",
  components: {Header},
  promocionesServicio: new PromocionesService(),
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loadingPromos: false,
    loading: false,
    nombrePromocion: "",

    fields: [
      {key: "idPromocion", label: "ID ", sortable: true},
      {key: "promocion", label: "promoción", sortable: true},
      {key: "categoria", label: "Categoría"},
      {key: "tipoDescuento", label: "Tipo"},
      {key: "estado", label: "Estado"},
      {key: "fechaAlta", label: "Fecha Alta"},
      {key: "fechaModificacion", label: "Fecha Modificación"},
      {key: "nombreUsuarioModificacion", label: "Usuario Modificación"},
      {key: "tipoVigencia", label: "Tipo Vigencia"},
      {key: "del", label: "Del"},
      {key: "al", label: "Al"},
      "Acciones",
    ],
    currentPage: 1,
    items: [],
    registrosPorPagina:10,
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
    listaFiltro: []
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerPromociones();
  },
  methods: {

    buscarPromos(){

      // this.listaFiltro = [];
      if (this.nombrePromocion !== null && this.nombrePromocion !== '') {
        this.items = this.listaFiltro.filter(item => item.promocion.toLowerCase().includes((this.nombrePromocion.toLowerCase())));
      }else{
        this.items = this.listaFiltro;
      }
    },

    editarPromo(idPromo){
      this.$router.push({name : 'PromocionesV2',params:{id: idPromo}})
    },
    cambiarEstatusPromo(idPromo, estatus, item){
      var text = estatus ? "¿Está seguro de activar la promoción?" : "¿Está seguro de desactivar la promoción? "
      this.$swal({
        icon: "warning",
        text: text,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if(aceptar.value) {
          const params = {
            idPromocion: idPromo
          }
          this.$http
              .put(this.$api + "promocionV2/cambiarEstatus", params)
              .then((response) => {
                if (response.data.data){
                  item.registroActivo = !item.registroActivo

                  this.obtenerPromociones();

                  miniToastr.success("Datos guardados con exito");
                }
              })
        }
      })
    },
    validarReactivacion(item){
      const finPromo = new Date(item.idTipoVigencia === 1 ? item.fechaFin : item.fechaFinCita);
      const fechaActual = new Date();
      if (finPromo > fechaActual){
        this.cambiarEstatusPromo(item.idPromocion, true, item);
      }else{
        this.editarPromo(item.idPromocion);
      }
    },
    obtenerPromociones(){
      this.loading = true;
      this.items = [];
      this.listaFiltro = [];
      this.$http.post(this.$api + 'promocionV2/obtenerPromos', this.filtro).then(respuesta => {
        this.items = respuesta.data.data
        this.listaFiltro = respuesta.data.data
      }).finally(()=> {
        this.loading = false;
      })
    },
    crearNuevaPromo(){
      this.$router.push({name: "PromocionesV2", params: {id: 0}});
    }
  }

}
</script>

<style scoped>

</style>